import React, { useEffect, useState } from 'react';

const Modal = ({ isOpen, closeModal, imageSrc, imageTitle }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setTimeout(() => setVisible(true), 10);
        } else {
            setVisible(false);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div 
            className={`modal-overlay ${visible ? "show" : ""}`} 
            onClick={closeModal}
            role="dialog"
            aria-modal="true"
            aria-label="Image modal"
        >
            <div 
                className={`modal-content ${visible ? "active" : ""}`} 
                onClick={(e) => e.stopPropagation()}
            >
                <button 
                    className="close-btn" 
                    onClick={closeModal}
                    aria-label="Close modal"
                >
                    ×
                </button>
                <img 
                    src={imageSrc} 
                    alt={imageTitle || "Haseki Sultan Kız Yurdu - Galeri Görseli"} 
                    title={imageTitle || "Haseki Sultan Kız Yurdu - Galeri Görseli"}
                    className="modal-image" 
                />
            </div>
        </div>
    );
};

export default Modal;
